var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex flex-row flex-align-center width-100 my-4 tabs-container"},_vm._l((_vm.useInspirationTags),function(tab){return _c('InspirationCenterTab',{key:tab,attrs:{"tab":tab,"isSelected":_vm.isTabSelected(tab)},on:{"tab-clicked":_vm.onTabClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }